/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddReserveItemPenaltyAmountRequest } from '../model';
// @ts-ignore
import { CancelIncompleteRoomReserve } from '../model';
// @ts-ignore
import { CancelIncompleteRoomReserveResponse } from '../model';
// @ts-ignore
import { CancelRoomRequest } from '../model';
// @ts-ignore
import { ChangeReserveStatus } from '../model';
// @ts-ignore
import { CheckRoomStatusResponse } from '../model';
// @ts-ignore
import { ConnectFloatingReservesRequest } from '../model';
// @ts-ignore
import { FinalizeManualReserveRequest } from '../model';
// @ts-ignore
import { FloatingReserveAcceptRequest } from '../model';
// @ts-ignore
import { FloatingReserveGeneralResponse } from '../model';
// @ts-ignore
import { FloatingReserveResponse } from '../model';
// @ts-ignore
import { FloatingReservesView } from '../model';
// @ts-ignore
import { HotelBlockDetailDto } from '../model';
// @ts-ignore
import { ProblemDetails } from '../model';
// @ts-ignore
import { ReserveFinancialEditRequest } from '../model';
// @ts-ignore
import { ReserveItemStatus } from '../model';
// @ts-ignore
import { ReserveTicketResponse } from '../model';
// @ts-ignore
import { ReserveView } from '../model';
// @ts-ignore
import { ReservedRoomDetailResponse } from '../model';
// @ts-ignore
import { RoomCancellationPenaltyResponse } from '../model';
// @ts-ignore
import { RoomCancellationResponse } from '../model';
// @ts-ignore
import { StartManualReserveRequest } from '../model';
// @ts-ignore
import { StartManualReserveResponse } from '../model';
/**
 * ReserveApiApiReserveAddReserveItemPenaltyPost - axios parameter creator
 * 
 * @param {AddReserveItemPenaltyAmountRequest} [addReserveItemPenaltyAmountRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveAddReserveItemPenaltyPostAxiosParamCreator (addReserveItemPenaltyAmountRequest?: AddReserveItemPenaltyAmountRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/AddReserveItemPenalty`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addReserveItemPenaltyAmountRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveBillCodeAutoCompletePost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} [xPlayerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveBillCodeAutoCompletePostAxiosParamCreator (billCode: string, xPlayerId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveBillCodeAutoCompletePost', 'billCode', billCode)
    const localVarPath = `/api/Reserve/{billCode}/auto-complete`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPost - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} reserveItemId 
 * @param {CancelIncompleteRoomReserve} [cancelIncompleteRoomReserve] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPostAxiosParamCreator (billCode: string, reserveItemId: number, cancelIncompleteRoomReserve?: CancelIncompleteRoomReserve, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveBillCodeCancelBeforeReserveReserveItemIdPost', 'billCode', billCode)
    // verify required parameter 'reserveItemId' is not null or undefined
    assertParamExists('apiReserveBillCodeCancelBeforeReserveReserveItemIdPost', 'reserveItemId', reserveItemId)
    const localVarPath = `/api/Reserve/{billCode}/cancel-before-reserve/{reserveItemId}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"reserveItemId"}}`, encodeURIComponent(String(reserveItemId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(cancelIncompleteRoomReserve, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveBillCodeChangeStatusPut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {ChangeReserveStatus} [changeReserveStatus] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveBillCodeChangeStatusPutAxiosParamCreator (billCode: string, changeReserveStatus?: ChangeReserveStatus, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveBillCodeChangeStatusPut', 'billCode', billCode)
    const localVarPath = `/api/Reserve/{billCode}/change-status`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(changeReserveStatus, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveBillCodeFinalizableGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} billId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveBillCodeFinalizableGetAxiosParamCreator (billCode: string, billId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveBillCodeFinalizableGet', 'billCode', billCode)
    // verify required parameter 'billId' is not null or undefined
    assertParamExists('apiReserveBillCodeFinalizableGet', 'billId', billId)
    const localVarPath = `/api/Reserve/{billCode}/finalizable`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveBillCodeFinalizedTicketGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveBillCodeFinalizedTicketGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveBillCodeFinalizedTicketGet', 'billCode', billCode)
    const localVarPath = `/api/Reserve/{billCode}/finalizedTicket`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveBillCodeTicketGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveBillCodeTicketGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveBillCodeTicketGet', 'billCode', billCode)
    const localVarPath = `/api/Reserve/{billCode}/ticket`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveByIdBillIdFinalizableGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {number} billId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveByIdBillIdFinalizableGetAxiosParamCreator (billCode: string, billId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveByIdBillIdFinalizableGet', 'billCode', billCode)
    // verify required parameter 'billId' is not null or undefined
    assertParamExists('apiReserveByIdBillIdFinalizableGet', 'billId', billId)
    const localVarPath = `/api/Reserve/byId/{billId}/finalizable`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"billId"}}`, encodeURIComponent(String(billId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveCheckStatusRoomIdGet - axios parameter creator
 * 
 * @param {number} roomId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveCheckStatusRoomIdGetAxiosParamCreator (roomId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'roomId' is not null or undefined
    assertParamExists('apiReserveCheckStatusRoomIdGet', 'roomId', roomId)
    const localVarPath = `/api/Reserve/check-status/{roomId}`
        .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveFloatingAcceptBillCodePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {Array<FloatingReserveAcceptRequest>} [floatingReserveAcceptRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveFloatingAcceptBillCodePutAxiosParamCreator (billCode: string, floatingReserveAcceptRequest?: Array<FloatingReserveAcceptRequest>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveFloatingAcceptBillCodePut', 'billCode', billCode)
    const localVarPath = `/api/Reserve/floating/Accept/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(floatingReserveAcceptRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveFloatingBillCodeMacGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {string} mac 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveFloatingBillCodeMacGetAxiosParamCreator (billCode: string, mac: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveFloatingBillCodeMacGet', 'billCode', billCode)
    // verify required parameter 'mac' is not null or undefined
    assertParamExists('apiReserveFloatingBillCodeMacGet', 'mac', mac)
    const localVarPath = `/api/Reserve/floating/{billCode}/{mac}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)))
        .replace(`{${"mac"}}`, encodeURIComponent(String(mac)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveFloatingGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveFloatingGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/floating`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveFloatingGetActiveFloatingReservesGet - axios parameter creator
 * 
 * @param {string} [xPlayerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveFloatingGetActiveFloatingReservesGetAxiosParamCreator (xPlayerId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/floating/GetActiveFloatingReserves`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveFloatingRejectBillCodePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveFloatingRejectBillCodePutAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveFloatingRejectBillCodePut', 'billCode', billCode)
    const localVarPath = `/api/Reserve/floating/Reject/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPost - axios parameter creator
 * 
 * @param {number} reserveId 
 * @param {ConnectFloatingReservesRequest} [connectFloatingReservesRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPostAxiosParamCreator (reserveId: number, connectFloatingReservesRequest?: ConnectFloatingReservesRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiReserveFloatingSetConnectedBillCodeReserveIdPost', 'reserveId', reserveId)
    const localVarPath = `/api/Reserve/floating/SetConnectedBillCode/{reserveId}`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(connectFloatingReservesRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveFloatingSetToWaitingBillCodePut - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveFloatingSetToWaitingBillCodePutAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveFloatingSetToWaitingBillCodePut', 'billCode', billCode)
    const localVarPath = `/api/Reserve/floating/SetToWaiting/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveReserveHotelSuggestionBillCodeGet - axios parameter creator
 * 
 * @param {string} billCode 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveReserveHotelSuggestionBillCodeGetAxiosParamCreator (billCode: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'billCode' is not null or undefined
    assertParamExists('apiReserveReserveHotelSuggestionBillCodeGet', 'billCode', billCode)
    const localVarPath = `/api/Reserve/ReserveHotelSuggestion/{billCode}`
        .replace(`{${"billCode"}}`, encodeURIComponent(String(billCode)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveReserveInformationsPost - axios parameter creator
 * 
 * @param {Array<number>} [requestBody] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveReserveInformationsPostAxiosParamCreator (requestBody?: Array<number>, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/Reserve/ReserveInformations`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveReserveReserveIdFinalizableGet - axios parameter creator
 * 
 * @param {number} reserveId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveReserveReserveIdFinalizableGetAxiosParamCreator (reserveId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiReserveReserveReserveIdFinalizableGet', 'reserveId', reserveId)
    const localVarPath = `/api/Reserve/reserve/{reserveId}/finalizable`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveReserveReserveIdTicketGet - axios parameter creator
 * 
 * @param {number} reserveId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveReserveReserveIdTicketGetAxiosParamCreator (reserveId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiReserveReserveReserveIdTicketGet', 'reserveId', reserveId)
    const localVarPath = `/api/Reserve/reserve/{reserveId}/ticket`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveRoomIdStartManualReservePut - axios parameter creator
 * 
 * @param {number} roomId 
 * @param {StartManualReserveRequest} [startManualReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveRoomIdStartManualReservePutAxiosParamCreator (roomId: number, startManualReserveRequest?: StartManualReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'roomId' is not null or undefined
    assertParamExists('apiReserveRoomIdStartManualReservePut', 'roomId', roomId)
    const localVarPath = `/api/Reserve/{roomId}/start-manual-reserve`
        .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(startManualReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveRoomIdUndoManualReservePut - axios parameter creator
 * 
 * @param {number} roomId 
 * @param {StartManualReserveRequest} [startManualReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveRoomIdUndoManualReservePutAxiosParamCreator (roomId: number, startManualReserveRequest?: StartManualReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'roomId' is not null or undefined
    assertParamExists('apiReserveRoomIdUndoManualReservePut', 'roomId', roomId)
    const localVarPath = `/api/Reserve/{roomId}/undo-manual-reserve`
        .replace(`{${"roomId"}}`, encodeURIComponent(String(roomId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(startManualReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveStatusReserveIdGet - axios parameter creator
 * 
 * @param {number} reserveId 
 * @param {string} [xPlayerId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveStatusReserveIdGetAxiosParamCreator (reserveId: number, xPlayerId?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'reserveId' is not null or undefined
    assertParamExists('apiReserveStatusReserveIdGet', 'reserveId', reserveId)
    const localVarPath = `/api/Reserve/status/{reserveId}`
        .replace(`{${"reserveId"}}`, encodeURIComponent(String(reserveId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerId != null) {
        localVarHeaderParameter['X-PlayerId'] = String(xPlayerId);
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveSuperPnrIdCancelPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {CancelRoomRequest} [cancelRoomRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveSuperPnrIdCancelPostAxiosParamCreator (superPnrId: number, cancelRoomRequest?: CancelRoomRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiReserveSuperPnrIdCancelPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Reserve/{superPnrId}/cancel`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(cancelRoomRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveSuperPnrIdFinalizeManualReservePut - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {FinalizeManualReserveRequest} [finalizeManualReserveRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveSuperPnrIdFinalizeManualReservePutAxiosParamCreator (superPnrId: number, finalizeManualReserveRequest?: FinalizeManualReserveRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiReserveSuperPnrIdFinalizeManualReservePut', 'superPnrId', superPnrId)
    const localVarPath = `/api/Reserve/{superPnrId}/finalize-manual-reserve`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(finalizeManualReserveRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveSuperPnrIdFinancialPut - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {ReserveFinancialEditRequest} [reserveFinancialEditRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveSuperPnrIdFinancialPutAxiosParamCreator (superPnrId: number, reserveFinancialEditRequest?: ReserveFinancialEditRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiReserveSuperPnrIdFinancialPut', 'superPnrId', superPnrId)
    const localVarPath = `/api/Reserve/{superPnrId}/financial`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(reserveFinancialEditRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveSuperPnrIdPenaltyGet - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {boolean} [isAdmin] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveSuperPnrIdPenaltyGetAxiosParamCreator (superPnrId: number, isAdmin?: boolean, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiReserveSuperPnrIdPenaltyGet', 'superPnrId', superPnrId)
    const localVarPath = `/api/Reserve/{superPnrId}/penalty`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (isAdmin !== undefined) {
        localVarQueryParameter['isAdmin'] = isAdmin;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveSuperPnrIdRoomDetailGet - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveSuperPnrIdRoomDetailGetAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiReserveSuperPnrIdRoomDetailGet', 'superPnrId', superPnrId)
    const localVarPath = `/api/Reserve/{superPnrId}/room-detail`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * ReserveApiApiReserveSuperPnrIdUndoCancellationPost - axios parameter creator
 * 
 * @param {number} superPnrId 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function ReserveApiApiReserveSuperPnrIdUndoCancellationPostAxiosParamCreator (superPnrId: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'superPnrId' is not null or undefined
    assertParamExists('apiReserveSuperPnrIdUndoCancellationPost', 'superPnrId', superPnrId)
    const localVarPath = `/api/Reserve/{superPnrId}/undo-cancellation`
        .replace(`{${"superPnrId"}}`, encodeURIComponent(String(superPnrId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiReserveAddReserveItemPenaltyPost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveAddReserveItemPenaltyPostRequest
 */
export interface ReserveApiApiReserveAddReserveItemPenaltyPostRequest {
    /**
     * 
     * @type {AddReserveItemPenaltyAmountRequest}
     * @memberof ReserveApiApiReserveAddReserveItemPenaltyPost
     */
    readonly addReserveItemPenaltyAmountRequest?: AddReserveItemPenaltyAmountRequest
}

/**
 * Request parameters for apiReserveBillCodeAutoCompletePost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveBillCodeAutoCompletePostRequest
 */
export interface ReserveApiApiReserveBillCodeAutoCompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveBillCodeAutoCompletePost
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveBillCodeAutoCompletePost
     */
    readonly xPlayerId?: string
}

/**
 * Request parameters for apiReserveBillCodeCancelBeforeReserveReserveItemIdPost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPostRequest
 */
export interface ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPost
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPost
     */
    readonly reserveItemId: number

    /**
     * 
     * @type {CancelIncompleteRoomReserve}
     * @memberof ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPost
     */
    readonly cancelIncompleteRoomReserve?: CancelIncompleteRoomReserve
}

/**
 * Request parameters for apiReserveBillCodeChangeStatusPut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveBillCodeChangeStatusPutRequest
 */
export interface ReserveApiApiReserveBillCodeChangeStatusPutRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveBillCodeChangeStatusPut
     */
    readonly billCode: string

    /**
     * 
     * @type {ChangeReserveStatus}
     * @memberof ReserveApiApiReserveBillCodeChangeStatusPut
     */
    readonly changeReserveStatus?: ChangeReserveStatus
}

/**
 * Request parameters for apiReserveBillCodeFinalizableGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveBillCodeFinalizableGetRequest
 */
export interface ReserveApiApiReserveBillCodeFinalizableGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveBillCodeFinalizableGet
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveBillCodeFinalizableGet
     */
    readonly billId: number
}

/**
 * Request parameters for apiReserveBillCodeFinalizedTicketGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveBillCodeFinalizedTicketGetRequest
 */
export interface ReserveApiApiReserveBillCodeFinalizedTicketGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveBillCodeFinalizedTicketGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiReserveBillCodeTicketGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveBillCodeTicketGetRequest
 */
export interface ReserveApiApiReserveBillCodeTicketGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveBillCodeTicketGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiReserveByIdBillIdFinalizableGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveByIdBillIdFinalizableGetRequest
 */
export interface ReserveApiApiReserveByIdBillIdFinalizableGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveByIdBillIdFinalizableGet
     */
    readonly billCode: string

    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveByIdBillIdFinalizableGet
     */
    readonly billId: number
}

/**
 * Request parameters for apiReserveCheckStatusRoomIdGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveCheckStatusRoomIdGetRequest
 */
export interface ReserveApiApiReserveCheckStatusRoomIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveCheckStatusRoomIdGet
     */
    readonly roomId: number
}

/**
 * Request parameters for apiReserveFloatingAcceptBillCodePut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveFloatingAcceptBillCodePutRequest
 */
export interface ReserveApiApiReserveFloatingAcceptBillCodePutRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveFloatingAcceptBillCodePut
     */
    readonly billCode: string

    /**
     * 
     * @type {Array<FloatingReserveAcceptRequest>}
     * @memberof ReserveApiApiReserveFloatingAcceptBillCodePut
     */
    readonly floatingReserveAcceptRequest?: Array<FloatingReserveAcceptRequest>
}

/**
 * Request parameters for apiReserveFloatingBillCodeMacGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveFloatingBillCodeMacGetRequest
 */
export interface ReserveApiApiReserveFloatingBillCodeMacGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveFloatingBillCodeMacGet
     */
    readonly billCode: string

    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveFloatingBillCodeMacGet
     */
    readonly mac: string
}

/**
 * Request parameters for apiReserveFloatingGetActiveFloatingReservesGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveFloatingGetActiveFloatingReservesGetRequest
 */
export interface ReserveApiApiReserveFloatingGetActiveFloatingReservesGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveFloatingGetActiveFloatingReservesGet
     */
    readonly xPlayerId?: string
}

/**
 * Request parameters for apiReserveFloatingRejectBillCodePut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveFloatingRejectBillCodePutRequest
 */
export interface ReserveApiApiReserveFloatingRejectBillCodePutRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveFloatingRejectBillCodePut
     */
    readonly billCode: string
}

/**
 * Request parameters for apiReserveFloatingSetConnectedBillCodeReserveIdPost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPostRequest
 */
export interface ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPost
     */
    readonly reserveId: number

    /**
     * 
     * @type {ConnectFloatingReservesRequest}
     * @memberof ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPost
     */
    readonly connectFloatingReservesRequest?: ConnectFloatingReservesRequest
}

/**
 * Request parameters for apiReserveFloatingSetToWaitingBillCodePut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveFloatingSetToWaitingBillCodePutRequest
 */
export interface ReserveApiApiReserveFloatingSetToWaitingBillCodePutRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveFloatingSetToWaitingBillCodePut
     */
    readonly billCode: string
}

/**
 * Request parameters for apiReserveReserveHotelSuggestionBillCodeGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveReserveHotelSuggestionBillCodeGetRequest
 */
export interface ReserveApiApiReserveReserveHotelSuggestionBillCodeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveReserveHotelSuggestionBillCodeGet
     */
    readonly billCode: string
}

/**
 * Request parameters for apiReserveReserveInformationsPost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveReserveInformationsPostRequest
 */
export interface ReserveApiApiReserveReserveInformationsPostRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof ReserveApiApiReserveReserveInformationsPost
     */
    readonly requestBody?: Array<number>
}

/**
 * Request parameters for apiReserveReserveReserveIdFinalizableGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveReserveReserveIdFinalizableGetRequest
 */
export interface ReserveApiApiReserveReserveReserveIdFinalizableGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveReserveReserveIdFinalizableGet
     */
    readonly reserveId: number
}

/**
 * Request parameters for apiReserveReserveReserveIdTicketGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveReserveReserveIdTicketGetRequest
 */
export interface ReserveApiApiReserveReserveReserveIdTicketGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveReserveReserveIdTicketGet
     */
    readonly reserveId: number
}

/**
 * Request parameters for apiReserveRoomIdStartManualReservePut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveRoomIdStartManualReservePutRequest
 */
export interface ReserveApiApiReserveRoomIdStartManualReservePutRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveRoomIdStartManualReservePut
     */
    readonly roomId: number

    /**
     * 
     * @type {StartManualReserveRequest}
     * @memberof ReserveApiApiReserveRoomIdStartManualReservePut
     */
    readonly startManualReserveRequest?: StartManualReserveRequest
}

/**
 * Request parameters for apiReserveRoomIdUndoManualReservePut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveRoomIdUndoManualReservePutRequest
 */
export interface ReserveApiApiReserveRoomIdUndoManualReservePutRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveRoomIdUndoManualReservePut
     */
    readonly roomId: number

    /**
     * 
     * @type {StartManualReserveRequest}
     * @memberof ReserveApiApiReserveRoomIdUndoManualReservePut
     */
    readonly startManualReserveRequest?: StartManualReserveRequest
}

/**
 * Request parameters for apiReserveStatusReserveIdGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveStatusReserveIdGetRequest
 */
export interface ReserveApiApiReserveStatusReserveIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveStatusReserveIdGet
     */
    readonly reserveId: number

    /**
     * 
     * @type {string}
     * @memberof ReserveApiApiReserveStatusReserveIdGet
     */
    readonly xPlayerId?: string
}

/**
 * Request parameters for apiReserveSuperPnrIdCancelPost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveSuperPnrIdCancelPostRequest
 */
export interface ReserveApiApiReserveSuperPnrIdCancelPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveSuperPnrIdCancelPost
     */
    readonly superPnrId: number

    /**
     * 
     * @type {CancelRoomRequest}
     * @memberof ReserveApiApiReserveSuperPnrIdCancelPost
     */
    readonly cancelRoomRequest?: CancelRoomRequest
}

/**
 * Request parameters for apiReserveSuperPnrIdFinalizeManualReservePut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveSuperPnrIdFinalizeManualReservePutRequest
 */
export interface ReserveApiApiReserveSuperPnrIdFinalizeManualReservePutRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveSuperPnrIdFinalizeManualReservePut
     */
    readonly superPnrId: number

    /**
     * 
     * @type {FinalizeManualReserveRequest}
     * @memberof ReserveApiApiReserveSuperPnrIdFinalizeManualReservePut
     */
    readonly finalizeManualReserveRequest?: FinalizeManualReserveRequest
}

/**
 * Request parameters for apiReserveSuperPnrIdFinancialPut operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveSuperPnrIdFinancialPutRequest
 */
export interface ReserveApiApiReserveSuperPnrIdFinancialPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveSuperPnrIdFinancialPut
     */
    readonly superPnrId: number

    /**
     * 
     * @type {ReserveFinancialEditRequest}
     * @memberof ReserveApiApiReserveSuperPnrIdFinancialPut
     */
    readonly reserveFinancialEditRequest?: ReserveFinancialEditRequest
}

/**
 * Request parameters for apiReserveSuperPnrIdPenaltyGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveSuperPnrIdPenaltyGetRequest
 */
export interface ReserveApiApiReserveSuperPnrIdPenaltyGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveSuperPnrIdPenaltyGet
     */
    readonly superPnrId: number

    /**
     * 
     * @type {boolean}
     * @memberof ReserveApiApiReserveSuperPnrIdPenaltyGet
     */
    readonly isAdmin?: boolean
}

/**
 * Request parameters for apiReserveSuperPnrIdRoomDetailGet operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveSuperPnrIdRoomDetailGetRequest
 */
export interface ReserveApiApiReserveSuperPnrIdRoomDetailGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveSuperPnrIdRoomDetailGet
     */
    readonly superPnrId: number
}

/**
 * Request parameters for apiReserveSuperPnrIdUndoCancellationPost operation in ReserveApi.
 * @export
 * @interface ReserveApiApiReserveSuperPnrIdUndoCancellationPostRequest
 */
export interface ReserveApiApiReserveSuperPnrIdUndoCancellationPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ReserveApiApiReserveSuperPnrIdUndoCancellationPost
     */
    readonly superPnrId: number
}

/**
* 
* @param {ReserveApiApiReserveAddReserveItemPenaltyPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveAddReserveItemPenaltyPost(requestParameters: ReserveApiApiReserveAddReserveItemPenaltyPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveAddReserveItemPenaltyPostAxiosParamCreator(requestParameters.addReserveItemPenaltyAmountRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveBillCodeAutoCompletePostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveBillCodeAutoCompletePost(requestParameters: ReserveApiApiReserveBillCodeAutoCompletePostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveBillCodeAutoCompletePostAxiosParamCreator(requestParameters.billCode, requestParameters.xPlayerId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPost(requestParameters: ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveBillCodeCancelBeforeReserveReserveItemIdPostAxiosParamCreator(requestParameters.billCode, requestParameters.reserveItemId, requestParameters.cancelIncompleteRoomReserve, options, configuration);
    const request: () => AxiosPromise<CancelIncompleteRoomReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveBillCodeChangeStatusPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveBillCodeChangeStatusPut(requestParameters: ReserveApiApiReserveBillCodeChangeStatusPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveBillCodeChangeStatusPutAxiosParamCreator(requestParameters.billCode, requestParameters.changeReserveStatus, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveBillCodeFinalizableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveBillCodeFinalizableGet(requestParameters: ReserveApiApiReserveBillCodeFinalizableGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveBillCodeFinalizableGetAxiosParamCreator(requestParameters.billCode, requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveBillCodeFinalizedTicketGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveBillCodeFinalizedTicketGet(requestParameters: ReserveApiApiReserveBillCodeFinalizedTicketGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveBillCodeFinalizedTicketGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<ReserveTicketResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveBillCodeTicketGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveBillCodeTicketGet(requestParameters: ReserveApiApiReserveBillCodeTicketGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveBillCodeTicketGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<ReserveTicketResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveByIdBillIdFinalizableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveByIdBillIdFinalizableGet(requestParameters: ReserveApiApiReserveByIdBillIdFinalizableGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveByIdBillIdFinalizableGetAxiosParamCreator(requestParameters.billCode, requestParameters.billId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveCheckStatusRoomIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveCheckStatusRoomIdGet(requestParameters: ReserveApiApiReserveCheckStatusRoomIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveCheckStatusRoomIdGetAxiosParamCreator(requestParameters.roomId, options, configuration);
    const request: () => AxiosPromise<CheckRoomStatusResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveFloatingAcceptBillCodePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveFloatingAcceptBillCodePut(requestParameters: ReserveApiApiReserveFloatingAcceptBillCodePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveFloatingAcceptBillCodePutAxiosParamCreator(requestParameters.billCode, requestParameters.floatingReserveAcceptRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveFloatingBillCodeMacGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveFloatingBillCodeMacGet(requestParameters: ReserveApiApiReserveFloatingBillCodeMacGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveFloatingBillCodeMacGetAxiosParamCreator(requestParameters.billCode, requestParameters.mac, options, configuration);
    const request: () => AxiosPromise<FloatingReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveFloatingGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveFloatingGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<FloatingReservesView>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveFloatingGetActiveFloatingReservesGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveFloatingGetActiveFloatingReservesGet(requestParameters: ReserveApiApiReserveFloatingGetActiveFloatingReservesGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveFloatingGetActiveFloatingReservesGetAxiosParamCreator(requestParameters.xPlayerId, options, configuration);
    const request: () => AxiosPromise<Array<FloatingReserveGeneralResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveFloatingRejectBillCodePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveFloatingRejectBillCodePut(requestParameters: ReserveApiApiReserveFloatingRejectBillCodePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveFloatingRejectBillCodePutAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPost(requestParameters: ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveFloatingSetConnectedBillCodeReserveIdPostAxiosParamCreator(requestParameters.reserveId, requestParameters.connectFloatingReservesRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveFloatingSetToWaitingBillCodePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveFloatingSetToWaitingBillCodePut(requestParameters: ReserveApiApiReserveFloatingSetToWaitingBillCodePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveFloatingSetToWaitingBillCodePutAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveReserveHotelSuggestionBillCodeGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveReserveHotelSuggestionBillCodeGet(requestParameters: ReserveApiApiReserveReserveHotelSuggestionBillCodeGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveReserveHotelSuggestionBillCodeGetAxiosParamCreator(requestParameters.billCode, options, configuration);
    const request: () => AxiosPromise<Array<HotelBlockDetailDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveReserveInformationsPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveReserveInformationsPost(requestParameters: ReserveApiApiReserveReserveInformationsPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveReserveInformationsPostAxiosParamCreator(requestParameters.requestBody, options, configuration);
    const request: () => AxiosPromise<Array<ReserveView>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveReserveReserveIdFinalizableGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveReserveReserveIdFinalizableGet(requestParameters: ReserveApiApiReserveReserveReserveIdFinalizableGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveReserveReserveIdFinalizableGetAxiosParamCreator(requestParameters.reserveId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveReserveReserveIdTicketGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveReserveReserveIdTicketGet(requestParameters: ReserveApiApiReserveReserveReserveIdTicketGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveReserveReserveIdTicketGetAxiosParamCreator(requestParameters.reserveId, options, configuration);
    const request: () => AxiosPromise<ReserveTicketResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveRoomIdStartManualReservePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveRoomIdStartManualReservePut(requestParameters: ReserveApiApiReserveRoomIdStartManualReservePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveRoomIdStartManualReservePutAxiosParamCreator(requestParameters.roomId, requestParameters.startManualReserveRequest, options, configuration);
    const request: () => AxiosPromise<StartManualReserveResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveRoomIdUndoManualReservePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveRoomIdUndoManualReservePut(requestParameters: ReserveApiApiReserveRoomIdUndoManualReservePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveRoomIdUndoManualReservePutAxiosParamCreator(requestParameters.roomId, requestParameters.startManualReserveRequest, options, configuration);
    const request: () => AxiosPromise<number> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveStatusReserveIdGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveStatusReserveIdGet(requestParameters: ReserveApiApiReserveStatusReserveIdGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveStatusReserveIdGetAxiosParamCreator(requestParameters.reserveId, requestParameters.xPlayerId, options, configuration);
    const request: () => AxiosPromise<ReserveItemStatus> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveSuperPnrIdCancelPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveSuperPnrIdCancelPost(requestParameters: ReserveApiApiReserveSuperPnrIdCancelPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveSuperPnrIdCancelPostAxiosParamCreator(requestParameters.superPnrId, requestParameters.cancelRoomRequest, options, configuration);
    const request: () => AxiosPromise<RoomCancellationResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveSuperPnrIdFinalizeManualReservePutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveSuperPnrIdFinalizeManualReservePut(requestParameters: ReserveApiApiReserveSuperPnrIdFinalizeManualReservePutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveSuperPnrIdFinalizeManualReservePutAxiosParamCreator(requestParameters.superPnrId, requestParameters.finalizeManualReserveRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveSuperPnrIdFinancialPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveSuperPnrIdFinancialPut(requestParameters: ReserveApiApiReserveSuperPnrIdFinancialPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveSuperPnrIdFinancialPutAxiosParamCreator(requestParameters.superPnrId, requestParameters.reserveFinancialEditRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveSuperPnrIdPenaltyGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveSuperPnrIdPenaltyGet(requestParameters: ReserveApiApiReserveSuperPnrIdPenaltyGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveSuperPnrIdPenaltyGetAxiosParamCreator(requestParameters.superPnrId, requestParameters.isAdmin, options, configuration);
    const request: () => AxiosPromise<RoomCancellationPenaltyResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveSuperPnrIdRoomDetailGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveSuperPnrIdRoomDetailGet(requestParameters: ReserveApiApiReserveSuperPnrIdRoomDetailGetRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveSuperPnrIdRoomDetailGetAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<ReservedRoomDetailResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {ReserveApiApiReserveSuperPnrIdUndoCancellationPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function ReserveApiApiReserveSuperPnrIdUndoCancellationPost(requestParameters: ReserveApiApiReserveSuperPnrIdUndoCancellationPostRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await ReserveApiApiReserveSuperPnrIdUndoCancellationPostAxiosParamCreator(requestParameters.superPnrId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
